import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";



function ProjectCards0(props) {
  return (
    <Card className="project-card-view">
      <Card.Img variant="top" src={props.imgPath} alt="card-img" />
      <Card.Body>
        <Card.Title>{props.title}</Card.Title>

        <p>
        <Button variant="primary" href={props.ghLink} target="_blank">
          {"U.S. Patent No. 11,613,384 B2"}
        </Button>
        </p>
        <p>
        <Button variant="primary" href={props.ghLink1} target="_blank">
          {"U.S. Patent No. 12,162,630 B2"}
        </Button>
        </p>
        <Card.Text style={{ textAlign: "center" }}>
          {props.description}
        </Card.Text>

        {"\n"}
        {"\n"}
      </Card.Body>
    </Card>
  );
}
export default ProjectCards0;
